<template>
  <div class="">
    <div class="fasi">
      <div class="fasi-item " :class="step >= 1 ? 'active' : ''">
        <div class=" fasi-item__dot"></div>
        <div class="fasi-item__period">9 Settembre - 10 Ottobre</div>
        <div class="fasi-item__label">RACCOGLIAMO LE RISPOSTE DEGLI ETS</div>

        <p class="fasi-item__description">
          Nel periodo di apertura della ricerca riuniamo le opinioni degli Enti che hanno aderito allo studio.
        </p>
      </div>
      <div class="fasi-item" :class="step >= 2 ? 'active' : ''">
        <div class="fasi-item__dot"></div>
        <div class="fasi-item__period">25-27 Settembre</div>
        <div class="fasi-item__label">ASCOLTIAMO LA VOCE DEI PROTAGONISTI
        </div>

        <p class="fasi-item__description">
          Approfondiamo dati ed esperienze con la testimonianza diretta degli Enti coinvolti in alcuni focus group.
        </p>
      </div>
      <div class="fasi-item" :class="step >= 3 ? 'active' : ''">
        <div class=" fasi-item__dot"></div>
        <div class="fasi-item__period">Ottobre 2024 - Gennaio 2025</div>
        <div class="fasi-item__label">ANALIZZIAMO I RISULTATI
        </div>

        <p class="fasi-item__description">
          Trasformiamo dati e testimonianze in risultati chiari e proposte.
        </p>
      </div>
      <div class="fasi-item" :class="step >= 4 ? 'active' : ''">
        <div class=" fasi-item__dot"></div>
        <div class="fasi-item__period">Da Febbraio 2025</div>
        <div class="fasi-item__label">LIBERO ACCESSO AI REPORT
        </div>

        <p class="fasi-item__description">
          Divulghiamo i risultati dello studio in appuntamenti dedicati e all'interno del Terzjus Report 2024.
        </p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  step: number
}>();



const { $event } = useNuxtApp();
const openContactModal = (action, value) => {
  $event('modal:contact', { action, value });
};

</script>